// Video titles: curated list first, then the Worker's oEmbed proxy,
// cached in localStorage so each title is fetched once per device.
import curatedVideos from '../data/videos.json';

const CACHE_KEY = 'ezshadowVideoTitles.v1';

const curatedTitles = {};
curatedVideos.forEach(v => {
  curatedTitles[v.videoId] = v.title;
});

export function getCuratedVideos() {
  return curatedVideos;
}

/** Title string, or null when unknown. Cached, safe to call often. */
export async function getVideoTitle(videoId) {
  if (curatedTitles[videoId]) return curatedTitles[videoId];

  const cache = loadCache();
  if (cache[videoId] !== undefined) return cache[videoId];

  const apiUrl = process.env.TRANSCRIPT_API_URL;
  if (!apiUrl) return null;

  try {
    const res = await fetch(`${apiUrl}/v1/videoinfo?videoId=${encodeURIComponent(videoId)}`);
    if (!res.ok) return null;
    const body = await res.json();
    cache[videoId] = body.title || null;
    saveCache(cache);
    return cache[videoId];
  } catch (e) {
    return null;
  }
}

function loadCache() {
  try {
    const parsed = JSON.parse(localStorage.getItem(CACHE_KEY));
    if (parsed && typeof parsed === 'object') return parsed;
  } catch (e) { /* corrupt -> fresh */ }
  return {};
}

function saveCache(cache) {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify(cache));
  } catch (e) { /* storage unavailable */ }
}
